import * as _ from 'lodash'

import { FileDto } from './file.dto'
import { MallServicePageDataDto } from './mall-service-page.dto'
import { TranslationDto } from './translation.dto'

export class FindPageDto {
  public searchText: string
}

export class PageDto {
  id: string
  title: TranslationDto
  content: TranslationDto
  slug: string
  data: MallServicePageDataDto
  enabledLinkButton: boolean
  enabledContent: boolean
  image?: FileDto

  static create() {
    return _.assign<PageDto>({
      id:'',
      title : TranslationDto.create(),
      content : TranslationDto.create(),
      slug : '',
      data: MallServicePageDataDto.create()
    })
  }
}
